<template>
    <div class="investor" :class="{ 'no-scroll': showList }">
        <div class="header">
            <div class="left">
                <a class="logo" href="/mobile/cn/sc/prd/home">
                    <img src="@/assets/images/investorRelation/logo.png" />
                </a>
                <div class="title">投资者关系</div>
            </div>
            <div class="menu" :class="{ active: showList }" @click="showList = !showList"></div>
            <div v-show="showList" class="list-wrap" @click="showList = !showList">
                <div class="list">
                    <a v-for="item in menus" :key="item.code" class="item" :class="{ active: curMenu === item.key }" :href="item.link">
                        <div>{{ item.title }}</div>
                    </a>
                </div>
            </div>
        </div>
        <router-view />
        <div class="cr">@2017顺丰速运版权所有 粤ICP备08034243</div>
        <to-top></to-top>
    </div>
</template>

<script>
import toTop from '@/components/to-top'
import { mapMutations } from 'vuex'
import ajax from '@/api/ajax'

export default {
    name: 'Investor',
    components: {
        toTop
    },
    data() {
        return {
            showList: false,
            curMenu: '',
            menus: []
        }
    },
    computed: {},
    watch: {},
    created() {
        this.setShowHeader(false)
        this.setShowFooter(false)
        this.curMenu = this.$route.name
        if (this.$route.name === 'reportList' || this.$route.name === 'recentList') {
            this.curMenu = 'report'
        }
        ajax.getHomeMenus().then(res => {
            if (res && res.headerMenu) {
                const tempArr = res.headerMenu
                this.menus = tempArr.find(item => item.key === 'investorRelation').children
            }
        })
    },
    methods: {
        ...mapMutations({
            setShowHeader: 'setShowHeader',
            setShowFooter: 'setShowFooter'
        })
    }
}
</script>

<style lang="scss" scoped>
.investor {
    .header {
        background: #303030;
        padding: 24px 40px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        .left {
            display: flex;
            align-items: center;
            .logo {
                height: 52px;
                width: 52px;
                img {
                    width: 100%;
                }
            }
            .title {
                color: #ffffff;
                font-weight: 500;
                font-size: 28px;
                margin-left: 20px;
            }
        }
        .menu {
            width: 36px;
            height: 36px;
            background: url('~@/assets/images/investorRelation/w-menu.png') center / cover;
            &.active {
                background: url('~@/assets/images/investorRelation/r-menu.png') center / cover;
            }
        }
        .list-wrap {
            position: fixed;
            top: 100px;
            left: 0;
            height: calc(100vh - 100px);
            width: 100%;
            z-index: 2;
            background: rgba(0, 0, 0, 0.8);
            font-weight: 500;
            font-size: 28px;
            color: #ffffff;
            .list {
                padding: 10px 18px 40px 40px;
                display: flex;
                flex-wrap: wrap;
                background: #303030;
                .item {
                    margin-top: 20px;
                    margin-right: 22px;
                    width: 324px;
                    padding: 30px 0;
                    font-weight: 500;
                    font-size: 28px;
                    color: #ffffff;
                    background: rgba(255, 255, 255, 0.05);
                    border-radius: 16px;
                    text-align: center;
                    &.active {
                        background: #ce0e2d;
                    }
                }
            }
        }
    }
    .cr {
        font-weight: 400;
        font-size: 24px;
        line-height: 32px;
        padding: 60px 0;
        color: #b3b3b3;
        text-align: center;
    }
}
.no-scroll {
    overflow-y: hidden;
    height: 100vh;
}
</style>



// WEBPACK FOOTER //
// src/pages/investor/index.vue